import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateAvailableCarts } from '../../store/ducks/tables/actions';
import { FreightRequest } from '../../store/ducks/freight/types';

export function toTwoDecimalPlaces(value: number): number {
  return value ? parseFloat(value.toFixed(2)) : 0;
}

export default function useGetDeliveriesRequests() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(
    freightRequestId?: string,
    freightId?: string,
    cartId?: string,
  ): Promise<FreightRequest | undefined> {
    if (!freightRequestId && !freightId && !cartId) {
      setLoading(false);
      return undefined;
    }

    try {
      setLoading(true);
      const params: Record<string, string> = {};
      if (freightRequestId) params.freightRequestId = freightRequestId;
      if (freightId) params.freightId = freightId;
      if (cartId) params.cartId = cartId;

      const response = await api.get(`v1/backoffice/delivery-requests/`, {
        params,
      });
      if (response.status === 200) {
        dispatch(populateAvailableCarts(response.data));
        return response.data;
      }
    } catch (error) {
      toast.error(ToastMessages.general.error.operationFailed);
    } finally {
      setLoading(false);
    }
    return undefined;
  }
  return { execute, loading };
}
